export default "__VITE_ASSET__KIJaj6Ca__"